export default __webpack_public_path__ + "static/pushout-037680d338060ca7acae214515f90405.png";